export default __webpack_public_path__ + "static/sky-4c98585d453d8aab033799e98f786565.svg";